var map = {
	"./": 18305,
	"./App": 9555,
	"./App.css": 93508,
	"./App.js": 9555,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./components/Card": 28619,
	"./components/Card.js": 28619,
	"./components/Game": 51719,
	"./components/Game.js": 51719,
	"./components/GameIntroView": 25947,
	"./components/GameIntroView.js": 25947,
	"./components/ModalView": 80038,
	"./components/ModalView.js": 80038,
	"./components/TopBar": 9054,
	"./components/TopBar.js": 9054,
	"./components/calculateDistance": 53763,
	"./components/calculateDistance.js": 53763,
	"./components/card.css": 21096,
	"./components/gameRules": 66057,
	"./components/gameRules.js": 66057,
	"./components/progress-bar.component": 87244,
	"./components/progress-bar.component.js": 87244,
	"./components/useJsonData": 2285,
	"./components/useJsonData.js": 2285,
	"./components/useOnScreen": 6544,
	"./components/useOnScreen.js": 6544,
	"./components/usePersistantState": 39701,
	"./components/usePersistantState.js": 39701,
	"./components/useScrollBlock": 74605,
	"./components/useScrollBlock.js": 74605,
	"./gameManager": 73912,
	"./gameManager.js": 73912,
	"./images/award.afdesign": 32066,
	"./images/awards/Campus_true.png": 26081,
	"./images/awards/Nightlife_true.png": 9831,
	"./images/awards/Sightseeing_true.png": 90118,
	"./images/awards/badge-Campus.png": 65337,
	"./images/awards/badge-Nightlife.png": 82413,
	"./images/awards/badge-Nightlife_false.png": 14873,
	"./images/awards/badge-Sightseeing.png": 34989,
	"./images/awards/badge-Sightseeing_false.png": 94096,
	"./images/awards/badge-University.png": 59990,
	"./images/awards/badge-none.png": 25453,
	"./images/background.jpg": 91942,
	"./images/cityRunLogo.png": 33888,
	"./images/logo-colearn-ccc.png": 25220,
	"./images/logo.jpg": 62369,
	"./images/logoOnly.png": 81522,
	"./images/logo_run.png": 91434,
	"./images/ort1.jpg": 6675,
	"./images/ort2.jpg": 95620,
	"./images/ort3.jpg": 8591,
	"./index": 18305,
	"./index.css": 51174,
	"./index.js": 18305,
	"./logo.svg": 31100,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./setupTests": 79511,
	"./setupTests.js": 79511,
	"./staticdata": 5959,
	"./staticdata.json": 5959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;